import { cleanPrecacheAndUnregisterServiceWorkers } from './serviceWorker/utils/serviceWorker.utils';

export const reloadAppBroadcastChannel = new BroadcastChannel('reset-app');
export const reloadAppBroadcastMessage = 'reset';
export const redirectToRootBroadcastMessage = 'redirect-root';

export const reloadAllTabsOfApp = () => {
  reloadAppBroadcastChannel.postMessage(reloadAppBroadcastMessage);
};

export const redirectAllTabsToRoot = () => {
  reloadAppBroadcastChannel.postMessage(redirectToRootBroadcastMessage);
};

export const resetApp = async () => {
  localStorage.clear();

  await cleanPrecacheAndUnregisterServiceWorkers();

  reloadAllTabsOfApp();
};
